export default {
    // host: "http://localhost/snapbill/",
    // host: "http://192.168.1.151/snapbill/",
    host: "https://snapbill.app/api/",
    // host: "https://floralwhite-rook-611806.hostingersite.com/api/",
}